import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import LevelServices from "./Level.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetLevel = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL,
      payload: true,
    });
    dispatch({
      type: actions.GET_LEVEL,
      payload: {
        levels: [],
        levelsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL,
      payload: false,
    });
  }
};

export const getLevel = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_LEVEL,
      payload: true,
    });
    const resp = await LevelServices.getLevel(filters);
    dispatch({
      type: actions.GET_LEVEL,
      payload: {
        levels: resp.data.data || [],
        levelsLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL,
      payload: false,
    });
  }
};

export const getLevelById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL_BY_ID,
      payload: true,
    });
    const resp = await LevelServices.getLevelById(id);
    dispatch({
      type: actions.GET_LEVEL_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL_BY_ID,
      payload: false,
    });
  }
};

export const saveLevel = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL,
      payload: true,
    });
    const resp = await LevelServices.saveLevel(data);
    const { levels, levelsLength } = getState().level;
    const _levels = [...levels, resp.data];
    dispatch({
      type: actions.GET_LEVEL,
      payload: {
        levels: _levels,
        levelsLength: levelsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL,
      payload: false,
    });
  }
};

export const editLevel = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL,
      payload: true,
    });
    const resp = await LevelServices.editLevel(id, data);
    const { levels, levelsLength } = getState().level;
    levels[index] = resp.data;
    dispatch({
      type: actions.GET_LEVEL,
      payload: {
        levels: levels,
        levelsLength: levelsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL,
      payload: false,
    });
  }
};

export const deleteLevel = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL,
      payload: true,
    });
    await LevelServices.deleteLevel(id);
    const { levels, levelsLength } = getState().level;
    levels.splice(index, 1);
    dispatch({
      type: actions.GET_LEVEL,
      payload: {
        levels: levels,
        levelsLength: levelsLength - 1,
      },
    });
    dispatch({
      type: actions.LEVEL_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL,
      payload: false,
    });
  }
};
